<template>
  <div class="timeline timeline-sides" style="width: 100%; color: rgba(0, 0, 0, 0.54);">
    <div
      v-for="(timeEvent, index) in timeEvents"
      :key="`history-order-timeline-events-${index}`"
      v-if="timeEvent.time"
      class="timeline-item">
      <div class="timeline-item-date" style="background-color: white;">
        {{ moment.tz(timeEvent.time, 'utc').tz('Asia/Taipei').format('DD') }}
        <small>{{ moment.tz(timeEvent.time, 'utc').tz('Asia/Taipei').format('MMM') }}</small>
      </div>
      <div class="timeline-item-divider"></div>
      <div class="timeline-item-content">
        <div class="timeline-item-inner">
          <div class="timeline-item-time">{{ moment.tz(timeEvent.time, 'utc').tz('Asia/Taipei').format('HH:mm') }}</div>
          <div class="timeline-item-title">{{ timeEvent.title }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment-timezone'

export default {
  name: 'HistoryOrderTimeline',
  props: {
    order: Object
  },
  computed: {
    moment () { return moment },
    timeEvents () {
      const events = [
        { title: '付款完成', time: this.order.paidAt },
        { title: '收到訂單', time: this.order.receivedAt },
        { title: '開始預備', time: this.order.startPreparingAt },
        { title: '餐點完成', time: this.order.doneAt },
        { title: '取餐', time: this.order.deliveredAt },
        { title: '退款', time: this.order.refundedAt },
        { title: '列印', time: this.order.printedAt }
      ]
      events.sort((a, b) => moment(a.time).isAfter(b.time) ? 1 : -1)
      return events
    }
  }
}
</script>
